import { render, staticRenderFns } from "./TestSetting.vue?vue&type=template&id=94bf4428&scoped=true&"
import script from "./TestSetting.vue?vue&type=script&lang=js&"
export * from "./TestSetting.vue?vue&type=script&lang=js&"
import style0 from "./TestSetting.vue?vue&type=style&index=0&id=94bf4428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bf4428",
  null
  
)

export default component.exports